import React from 'react'

// Catalogo PDF statici, organizzati per sezione (Compagnia - Tariffa).
// Per aggiungere un documento:
// 1. Carica il file in /public/documenti/<filename>.pdf
// 2. Aggiungi una riga nella sezione corrispondente qui sotto
// 3. Commit + push: Vercel rideploya automaticamente
const BASE = `${process.env.PUBLIC_URL || ''}/documenti`

const SEZIONI = [
  {
    titolo: 'EIR',
    documenti: [
      { titolo: 'EIR - Set informativo', file: 'EIR-Informativa.pdf' },
    ],
  },
  {
    titolo: "Lloyd's Volante",
    documenti: [
      { titolo: 'Set informativo',           file: 'LloydsVolante-Informativa.pdf' },
      { titolo: 'Garanzie aggiuntive',       file: 'GaranzieAggiuntive-LLoydsVolante.pdf' },
      { titolo: 'Franchigie e scoperti',     file: 'FranchigieScoperti-LLoydsVolante.pdf' },
    ],
  },
  {
    titolo: "Lloyd's Plus",
    documenti: [
      { titolo: 'Set informativo',           file: 'LLoydsPlus-Informativa.pdf' },
      { titolo: 'Garanzie aggiuntive',       file: 'GaranzieAggiuntive-LLoydsPlus.pdf' },
      { titolo: 'Franchigie e scoperti',     file: 'FranchigieScopertiTariffaPlus.pdf' },
    ],
  },
  {
    titolo: "Lloyd's - Documenti comuni",
    documenti: [
      { titolo: 'Condizioni e allegati (Volante + Plus)', file: 'CondizioniAllegati-LLoydPlus-LLoydsVolante.pdf' },
    ],
  },
  {
    titolo: 'Covea',
    documenti: [
      { titolo: 'Set informativo', file: 'Covea-Informativa.pdf' },
    ],
  },
  {
    titolo: 'Quixa',
    documenti: [
      { titolo: 'Set informativo', file: 'Quixa-Informativa.pdf' },
    ],
  },
  {
    titolo: 'Sogessur',
    documenti: [
      { titolo: 'Set informativo', file: 'Sogessur-Informativa.pdf' },
    ],
  },
  {
    titolo: 'Wakam',
    documenti: [
      { titolo: 'Set informativo', file: 'wakam-set-informativo.pdf' },
    ],
  },
  {
    titolo: 'Stand alone',
    documenti: [
      { titolo: 'Cristalli - Nemesi',                  file: 'TerminiCondizioniCristalli-Nemesi.pdf' },
      { titolo: 'Silver Soccorso Stradale - Nemesi',   file: 'TerminiCondizioniSilverSoccorsoStradale-Nemesi.pdf' },
      { titolo: 'Tutela Legale - Polizza collettiva Diemmeci / ARAG', file: 'PolizzaCollettivaDiemmeci-Arag.pdf' },
    ],
  },
]

export default function Documentale() {
  return (
    <div>
      <div className="page-header">
        <h1>Documentale</h1>
        <p>Set informativi e condizioni di assicurazione di tutte le compagnie. Click su una card per scaricare il PDF.</p>
      </div>

      {SEZIONI.map(sez => (
        <div key={sez.titolo} className="card mt-2">
          <h2 className="card-title">{sez.titolo}</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {sez.documenti.map(d => (
              <a key={d.file}
                 href={`${BASE}/${d.file}`}
                 download
                 style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px',
                          textDecoration: 'none', color: 'var(--text)',
                          border: '1px solid var(--border)', borderRadius: 'var(--radius)',
                          cursor: 'pointer' }}>
                <span style={{ fontSize: 20 }}>📄</span>
                <span style={{ flex: 1 }}>{d.titolo}</span>
                <span className="text-small text-muted">⬇ scarica</span>
              </a>
            ))}
          </div>
        </div>
      ))}

      <div className="info-box mt-3">
        I PDF sono aggiornati dall'amministratore tramite repository Git. La sostituzione di un file
        con lo stesso nome rende la nuova versione disponibile a tutti i dealer al prossimo deploy.
      </div>
    </div>
  )
}
